import { ClassNameFormatter, NoStrictEntityMods, withNaming } from '@bem-react/classname';
import React from 'react';

export const cn = withNaming({ n: 'dc-', e: '__', m: '_' });

export function getClassNames(classNames: Array<string | null | undefined>) {
    return classNames.filter(Boolean).join(' ');
}

/**
 * Получение классов только с заданными модификациями
 * @param cls - генератор названий классов для элемента
 * @param modification - объект с модификациями, классы которых требуется получить
 *
 * @example const className = getModificationClassName(cn('Drawer'), { hideBorders: true });
 * В примере значение className будет `Drawer_hideBorders`, а не `Drawer Drawer_hideBorders`
 */
export function getModificationClassName(cls: ClassNameFormatter, modification: NoStrictEntityMods) {
    return cls(modification).replace(cls(), '').replace(' ', '');
}

export function addRootNodeClassName(
    element: React.ReactElement<{ className: string }>,
    rootClassName: string | undefined,
    props?: object,
) {
    if (rootClassName === undefined) {
        return element;
    }

    return React.cloneElement(element, {
        className: getClassNames([element.props.className, rootClassName]),
        ...props,
    });
}
